export const MAX_CRAWLABLE_BRAND_SHOP_PAGE = 500;
/** Products per crawlable brand shop page, and per Load more of its grid. */
export const BRAND_SHOP_PAGE_SIZE = 24;

export function parseBrandShopPageSegment(value: string): number | null {
  if (!/^\d+$/.test(value)) {
    return null;
  }

  const page = Number(value);
  return Number.isSafeInteger(page) && page > 0 && page <= MAX_CRAWLABLE_BRAND_SHOP_PAGE
    ? page
    : null;
}
